import { createActions } from 'utils/actions';

/**
 * Redux actions to store the MFA session, i.e. the short lived `mfa_token` and
 * the MFA details returned by the authenticate API.
 *
 * @type {Object}
 */
export const setMFASession = createActions('mfa', 'SET_MFA_SESSION');

/**
 * Redux actions to clear the MFA session.
 *
 * @type {Object}
 */
export const clearMFASession = createActions('mfa', 'CLEAR_MFA_SESSION');

/**
 * Redux actions for the MFA code verification flow.
 *
 * @type {Object}
 */
export const verifyMFACode = createActions('mfa', 'VERIFY_MFA_CODE');
